import React, { useState } from 'react'

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    description: ''
  })
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState('')

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setError('')

    try {
      const response = await fetch('https://n8n.srv1012278.hstgr.cloud/webhook/floristeria-lampugnani-dior-send-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          full_name: formData.name,
          phone: formData.phone,
          email: formData.email,
          event_description: formData.description
        })
      })

      if (response.ok) {
        window.location.hash = '#thank-you'
      } else {
        throw new Error('Errore durante l\'invio della richiesta')
      }
    } catch (err) {
      setError('Si è verificato un errore durante l\'invio. Riprova più tardi.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <section id="contact-section" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-serif font-bold text-brand-green mb-4">Contattaci Direttamente</h2>
          <p className="text-lg text-brand-text/70 max-w-3xl mx-auto mb-8">
            Hai domande specifiche o preferisci parlare con noi? Compila il form qui sotto oppure utilizza i nostri contatti diretti.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Form Section */}
          <div className="bg-brand-subtle-bg p-8 rounded-lg">
            {isSubmitted ? (
              <div className="text-center py-12 animate-fade-in">
                <h3 className="text-3xl font-serif text-brand-green mb-3">Grazie!</h3>
                <p className="text-brand-text/80">
                  Abbiamo ricevuto la tua richiesta. Ti contatteremo al più presto.
                </p>
              </div>
            ) : (
              <>
                <h3 className="text-2xl font-serif text-brand-green mb-6">Invia una Richiesta</h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <input
                    type="text"
                    name="name"
                    placeholder="Nome e Cognome*"
                    required
                    className="p-3 bg-white border border-transparent rounded-md w-full focus:ring-2 focus:ring-brand-green transition"
                    value={formData.name}
                    onChange={handleInputChange}
                    disabled={isSubmitting}
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Numero di Telefono*"
                    required
                    className="p-3 bg-white border border-transparent rounded-md w-full focus:ring-2 focus:ring-brand-green transition"
                    value={formData.phone}
                    onChange={handleInputChange}
                    disabled={isSubmitting}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email*"
                    required
                    className="p-3 bg-white border border-transparent rounded-md w-full focus:ring-2 focus:ring-brand-green transition"
                    value={formData.email}
                    onChange={handleInputChange}
                    disabled={isSubmitting}
                  />
                  <textarea
                    name="description"
                    placeholder="Descrivi il tuo locale e le tue esigenze*"
                    rows={4}
                    required
                    className="p-3 bg-white border border-transparent rounded-md w-full focus:ring-2 focus:ring-brand-green transition"
                    value={formData.description}
                    onChange={handleInputChange}
                    disabled={isSubmitting}
                  ></textarea>

                  {error && (
                    <p className="text-red-500 text-sm">{error}</p>
                  )}

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-brand-green text-white font-bold py-3 px-6 rounded-md hover:bg-brand-light-green transition-all duration-300 shadow-lg disabled:bg-gray-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <div className="flex items-center justify-center">
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Invio in corso...
                      </div>
                    ) : (
                      'Invia la tua Richiesta'
                    )}
                  </button>
                </form>
              </>
            )}
          </div>

          {/* Contact Info Section */}
          <div className="space-y-8">
            <h3 className="text-2xl font-serif text-brand-green mb-6">I Nostri Contatti</h3>

            <div className="space-y-6">
              <div className="flex items-center space-x-4">
                <div className="bg-brand-green/10 p-3 rounded-full">
                  <svg className="w-6 h-6 text-brand-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <p className="font-semibold text-brand-green">Email</p>
                  <a href="mailto:allestimentilampugnani@gmail.com" className="text-brand-text/70 hover:text-brand-green transition-colors">
                    allestimentilampugnani@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <div className="bg-brand-green/10 p-3 rounded-full">
                  <svg className="w-6 h-6 text-brand-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div>
                  <p className="font-semibold text-brand-green">Telefono</p>
                  <a href="tel:+393793130376" className="text-brand-text/70 hover:text-brand-green transition-colors">
                    +39 379 313 0376
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="bg-brand-green/10 p-3 rounded-full">
                  <svg className="w-6 h-6 text-brand-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <p className="font-semibold text-brand-green mb-2">Le Nostre Sedi</p>
                  <div className="space-y-3 text-brand-text/70">
                    <div>
                      <p className="font-medium text-brand-green text-sm">Sede Principale</p>
                      <p>Via Briantea 25c<br />22030 Orsenigo (CO)</p>
                    </div>
                    <div>
                      <p className="font-medium text-brand-green text-sm">Sede Milano</p>
                      <p>Via Michele Barozzi 6<br />20122 Milano (MI)</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactSection